import { Col, Form, Input, message, Modal, Row } from "antd";
import { Rule } from "antd/lib/form";
import { projectApi } from "api/project.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { ModalStatus } from "types/modal";
import { Project } from "types/project";

const rules: Rule[] = [{ required: true }];

export interface ProjectModal {
  handleCreate: () => void;
  handleUpdate: (Project: Project) => void;
  handleView: (Project: Project) => void;
}
interface ProjectModalProps {
  onClose: () => void;
  onSubmitOk: () => void;
}

export const ProjectModal = React.forwardRef(({ onClose, onSubmitOk }: ProjectModalProps, ref) => {
  const [form] = Form.useForm<Project>();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState<ModalStatus>("create");
  const [selectedProject, setSelectedProject] = useState<Project>();

  useImperativeHandle<any, ProjectModal>(
    ref,
    () => ({
      handleCreate() {
        form.resetFields();
        setVisible(true);
        setStatus("create");
        setSelectedProject(undefined);
      },
      handleUpdate(Project: Project) {
        form.setFieldsValue({ ...Project });
        setVisible(true);
        setStatus("update");
        setSelectedProject(Project);
      },
      handleView(Project: Project) {
        form.setFieldsValue({ ...Project });
        setVisible(true);
        setStatus("view");
        setSelectedProject(Project);
      },
    }),
    [],
  );

  const getPayload = () => {
    const { ...rest } = form.getFieldsValue();
    return { project: rest };
  };

  const submitForm = async () => {
    try {
      setLoading(true);
      const valid = await form.validateFields();
      const data = getPayload();
      let res: any = undefined;
      switch (status) {
        case "create":
          res = await projectApi.create(data);
          message.success("Tạo thành công!");
          break;
        case "update":
          res = await projectApi.update(selectedProject?.id || 0, data);
          message.success("Cập nhật thành công!");
          break;
      }
      onSubmitOk();
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose?.();
    setVisible(false);
    setSelectedProject(undefined);
  };

  return (
    <Modal
      onCancel={() => {
        handleClose();
      }}
      visible={visible}
      title={status == "create" ? "Tạo dự án" : status == "update" ? "Cập nhật dự án" : "Xem chi tiết dự án"}
      style={{ top: 20 }}
      width={700}
      confirmLoading={loading}
      onOk={submitForm}
      footer={status == "view" ? null : undefined}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tên dự án" name="name" rules={rules}>
              <Input placeholder="" disabled={status == "view"} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Tenant ID" name="tenantId" rules={rules}>
              <Input placeholder="" disabled={status == "view"} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Hệ thống prompt" name="systemPrompt" rules={rules}>
              <Input.TextArea rows={10} placeholder="" disabled={status == "view"} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item shouldUpdate={true}>
          {() => {
            return (
              <Form.Item label="Logo" name="logo">
                <SingleImageUpload
                  onUploadOk={(path: string) => {
                    console.log("onUploadOk:", path);
                    form.setFieldsValue({
                      logo: path,
                    });
                  }}
                  disabled={status == "view"}
                  imageUrl={form.getFieldValue("logo")}
                  uploadUrl={import.meta.env.VITE_API_URL + "/v1/admin/project/upload"}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
});
